import { Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRowParams } from '@mui/x-data-grid';
import { CloudController, DoorType } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';
import { getOverviewDataGridProps } from 'v2/components/DataGrid/getOverviewDataGridProps';
import LockIconNameCell from 'v2/components/LockIconNameCell/LockIconNameCell';
import { DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface Props {
  cloudControllers: CloudController[];
  onRowClick: (id: string) => void;
  loading?: boolean;
}

const TableWithData: React.FC<Props> = ({ cloudControllers, onRowClick, loading = false }) => {
  const { translation } = useTranslation();

  const columns: GridColDef<CloudController>[] = [
    {
      field: 'serial_number',
      headerName: translation.serial_number,
      flex: 1,
      valueGetter: (_, row) => row.serialNumber,
      renderHeader: () => (
        <ColumnHeaderWithTooltip
          id="header-serial_number"
          label={translation.serial_number}
          tooltip={<Typography variant="caption">{translation.serial_number_tooltip}</Typography>}
        />
      ),
      renderCell: (params) => (
        <LockIconNameCell door={{ name: params.row.serialNumber, type: DoorType.CloudControllerDoor }} />
      )
    }
  ];

  const overviewDataGridProps = getOverviewDataGridProps({ rowCount: cloudControllers.length, loading });

  return (
    <DataGrid
      {...overviewDataGridProps}
      rows={cloudControllers}
      columns={columns}
      rowHeight={DATAGRID_ROW_HEIGHT}
      onRowClick={(params: GridRowParams<CloudController>) => onRowClick(params.row.id)}
      initialState={{
        ...overviewDataGridProps.initialState,
        sorting: { sortModel: [{ field: 'serial_number', sort: 'asc' }] }
      }}
    />
  );
};

export default TableWithData;
